import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

export const DEFAULTS = {
  contact_address_1: "Münsterstraße 52",
  contact_address_2: "48249 Dülmen",
  contact_phone: "02594 / 97 10",
  contact_phone_link: "+49259497100",
  contact_email: "info@hotelwildpferd.com",
  hero_overline: "Hotel Wildpferd · Innenstadt Dülmen",
  hero_title_1: "Mitten in Dülmen",
  hero_title_2: "zuhause.",
  hero_subtitle: "Ihr schönes Stadthotel im Herzen von Dülmen — zentral gelegen, herzlich empfangen, entspannt wohnen. Und die Wildpferde der Merfelder Bruch warten nur 10 Minuten entfernt.",
  marquee_items: ["Innenstadt-Lage", "Persönlicher Service", "Frühstücksbuffet", "Restaurant & Bar", "Kostenfreie Parkplätze", "4 Min. zum Nonnenturm", "Wildpferde Merfelder Bruch"],
  manifesto_overline: "Kapitel I — Das Hotel",
  manifesto_title_1: "Gut schlafen in der",
  manifesto_title_2: "Dülmener Innenstadt.",
  manifesto_text_1: "Unser Traditionshaus in der Münsterstraße 52 liegt mitten im Herzen von Dülmen — vier Gehminuten vom Nonnenturm, einen Katzensprung von Cafés, Marktplatz und Einkaufsstraßen entfernt.",
  manifesto_text_2: "Bei uns läuft alles unkompliziert und persönlich: Einchecken jederzeit direkt bei uns vor Ort, ein Frühstücksbuffet, das unsere Gäste regelmäßig loben, und ein Team, das sich kümmert. Ob Geschäftsreise, Familienbesuch oder Wochenende zu zweit — das Wildpferd ist Ihr Zuhause in der Stadt.",
  manifesto_quote: "„Unkompliziert einchecken, richtig gut frühstücken, mittendrin sein.“",
  rooms_overline: "Kapitel II — Zimmer & Suiten",
  rooms_title_1: "Komfort & Business —",
  rooms_title_2: "mitten in der Stadt.",
  rooms_subline: "Alle Preise pro Zimmer und Nacht inklusive WLAN und Parkplatz. Frühstücksbuffet zubuchbar — Direktbucher fahren immer am besten.",
  region_overline: "Kapitel III — Stadt & Natur",
  region_title_1: "Altstadt-Flair und",
  region_title_2: "wilde Nachbarn.",
  region_spots: [],
  faq_items: [],
  footer_about: "Ihr Stadthotel in der Dülmener Innenstadt. Wir freuen uns auf Sie!",
  service_lines: ["Einchecken jederzeit persönlich vor Ort", "Ihr Zimmer ab 15:00 Uhr bereit", "Persönlich erreichbar: täglich 06:30 – 22:00 Uhr"],
  bank_recipient: "A&A Hotelbetriebe GbR",
  bank_iban: "DE66 2006 9177 0012 2077 96",
  bank_bic: "GENODEF1GRS",
  hero_image: "/images/restaurant.jpg",
  manifesto_image: "/images/hero.jpg",
  invoice_company: "A&A Hotelbetriebe GbR",
  invoice_tax_id: "",
  invoice_note: "Vielen Dank für Ihren Aufenthalt im Hotel Wildpferd Dülmen — wir freuen uns auf Ihren nächsten Besuch!",
  impressum_text: "",
  datenschutz_text: "",
  agb_text: "",
};

const Ctx = createContext(DEFAULTS);

export function ContentProvider({ children }) {
  const [content, setContent] = useState(DEFAULTS);
  useEffect(() => {
    api.get("/content")
      .then((r) => setContent({ ...DEFAULTS, ...r.data }))
      .catch(() => {});
  }, []);
  return <Ctx.Provider value={content}>{children}</Ctx.Provider>;
}

export const useContent = () => useContext(Ctx);
